module.exports = __webpack_public_path__ + "static/dobigthings-08beb21cd9094a793bdb6d87e8c552ba.png";